import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// 自托管 webfont(古地图气质):Cinzel 罗马刻字标题 + Spectral 衬线正文
import '@fontsource/cinzel/600.css';
import '@fontsource/cinzel/700.css';
import '@fontsource/spectral/400.css';
import '@fontsource/spectral/500.css';
import '@fontsource/spectral/600.css';
import App from './App';

function start() {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

// 关键字体加载好之后再渲染:首帧即终态字体,零 swap → 消除字体引起的 CLS(best-practice §9.x)。
// 字体已 preload(woff2),通常 ~200ms 就绪;最多等 1.8s 兜底。
const need = ['600 1rem "Cinzel"', '700 1rem "Cinzel"', '400 1rem "Spectral"', '500 1rem "Spectral"', '600 1rem "Spectral"'];
const fonts = (document as unknown as { fonts?: { load(f: string): Promise<unknown> } }).fonts;
if (fonts && fonts.load) {
  Promise.race([
    Promise.allSettled(need.map((f) => fonts.load(f))),
    new Promise((r) => setTimeout(r, 1800)),
  ]).then(start, start);
} else {
  start();
}
